var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('popup', {
    attrs: {
      "opened": _vm.showPopup
    },
    on: {
      "close": function ($event) {
        return _vm.togglePopup(false);
      }
    }
  }, [_vm.loading ? _c('div', {
    staticClass: "mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto flex flex-col items-center justify-center"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("\n        Préparation de votre reçu...\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "lds-roller my-15"
  }, [_c('div'), _c('div'), _c('div'), _c('div'), _c('div'), _c('div'), _c('div'), _c('div')])]) : _c('div', {
    staticClass: "mx-5 xl:mx-16 2xl:mx-20 mt-8 w-auto h-full flex flex-col items-center"
  }, [_c('div', {
    staticClass: "flex flex-col items-center"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("\n          Votre reçu est prêt !\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "my-15",
    attrs: {
      "href": _vm.downloadLink,
      "download": _vm.filename
    }
  }, [_c('action-button', {
    attrs: {
      "icon": "download",
      "libelle": "TELECHARGER",
      "border-color": "transparent",
      "bg-color": "bg-pink-600",
      "icon-color": "text-white",
      "text-color": "text-white"
    }
  })], 1)]), _vm._v(" "), _c('illustration', {
    attrs: {
      "name": "Group189"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "text-center text-sm italic text-pink-600 mt-5"
  }, [_vm._v("\n        Un problème avec le téléchargement ?"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "not-italic text-indigo-600 underline"
  }, [_c('a', {
    attrs: {
      "href": _vm.hostedInvoiceUrl,
      "target": "_blank"
    }
  }, [_vm._v("Cliquez ici")])])])], 1)]), _vm._v(" "), _vm.allowed && _vm.$subscribed() ? _c('div', {
    staticClass: "my-15"
  }, [_vm._m(0), _vm._v(" "), _vm._l(_vm.invoicesSortedByDate, function (invoice, invoiceIdx) {
    return _c('div', {
      key: invoiceIdx,
      staticClass: "grid grid-cols-12 gap-x-4 even:bg-indigo-200 even:bg-opacity-50 h-24 content-center items-center text-base"
    }, [_c('div', {
      staticClass: "col-span-2 pl-8"
    }, [_vm._v("\n        " + _vm._s(_vm.invoiceFormatDate(invoice.lines.data[0].period.start)) + " - " + _vm._s(_vm.invoiceFormatDate(invoice.lines.data[0].period.end)) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-4"
    }, [_c('tag', {
      attrs: {
        "theme-color": "indigo",
        "libelle": 'Standard: abonnement de ' + invoice.lines.data[0].quantity + ' Neopass',
        "text-size": "text-md"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-3"
    }, [_vm._v("\n        " + _vm._s(_vm.invoiceFormatDate(invoice.status_transitions.paid_at)) + " \n        " + _vm._s(invoice.lines.data[0].plan.interval === 'year' ? '(annuel)' : invoice.lines.data[0].plan.interval === 'month' ? '(mensuel)' : '') + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-1 font-medium"
    }, [_vm._v("\n        " + _vm._s((invoice.total / 100).toFixed(2)) + " €\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-1"
    }, [_c('circle-button', {
      attrs: {
        "icon": "download",
        "label": "Télécharger le reçu"
      },
      on: {
        "buttonClick": function ($event) {
          _vm.downloadInvoice(invoice.id, _vm.invoiceFormatDate(invoice.status_transitions.paid_at));
        }
      }
    })], 1)]);
  })], 2) : !_vm.$subscribed() && !_vm.allowed ? _c('div', [_c('div', {
    staticClass: "relative align-middle"
  }, [_c('h3', {
    staticClass: "mt-10 mb-5 w-full"
  }, [_vm._v("\n        Offre Gratuite\n      ")]), _vm._v(" "), _c('h6', {
    staticClass: "text-gray-600"
  }, [_vm._v("\n        Vous ne disposez pas d'historiques de paiement car vous bénéficiez d'un abonnement gratuit.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center mt-15"
  }, [_c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])]) : !_vm.allowed && _vm.$subscribed() ? _c('page-not-allowed-without-container') : _vm._e()], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 mb-10 text-gray-600 text-lg"
  }, [_c('div', {
    staticClass: "col-span-2 pl-8"
  }, [_vm._v("\n        Période\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4"
  }, [_vm._v("\n        Type d'offre\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3"
  }, [_vm._v("\n        Date de prélèvement\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1"
  }, [_vm._v("\n        Montant\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1"
  }, [_vm._v("\n        Télécharger\n      ")])]);

}]

export { render, staticRenderFns }